/**
 * Component Registry for Repli Sandbox Preferred Theme
 * 
 * Extends the base preferred theme registry with Repli Sandbox Preferred specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-preferred/registry';
import { Header } from './components/Header';
import { CTASection } from './components/CTASection';
import { Hero } from './components/Hero';

/**
 * Repli Sandbox Preferred specific component overrides.
 * Sidebar navigation replaces the default horizontal header.
 */
const replisandboxpreferredOverrides: Partial<ComponentRegistry> = {
  Header,
  CTASection,
  Hero,
};

/**
 * Final merged registry for Repli Sandbox Preferred properties.
 * Inherits all components from the preferred theme, with Repli Sandbox Preferred overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replisandboxpreferredOverrides,
};

export default registry;
